module.exports = __webpack_public_path__ + "img/imge12.8f57a027.png";